<template>

  <svg
    t="1639104900041"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4565"
    width="64"
    height="64"
  ><path d="M142.4 210.66666666v614.4h750.93333333V210.66666666H142.4z m0-68.26666667h750.93333333a68.26666667 68.26666667 0 0 1 68.26666667 68.26666667v614.4a68.26666667 68.26666667 0 0 1-68.26666667 68.26666667H142.4a68.26666667 68.26666667 0 0 1-68.26666669-68.26666667V210.66666666a68.26666667 68.26666667 0 0 1 68.26666669-68.26666667z" p-id="4566" /><path d="M347.2 579.30666666V688.53333332L210.66666667 517.86666666l136.53333333-170.66666666v109.22666666L298.048 517.86666666z m341.33333331-122.88V347.2l136.53333336 170.66666666-136.53333336 170.66666666V579.30666666l49.152-61.44zM551.99999998 347.2h68.26666667L483.73333333 688.53333332h-68.26666666z" p-id="4567" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMyData',
} as DefineComponent
</script>